import { render, staticRenderFns } from "./RSS.vue?vue&type=template&id=ed9fafb2&"
import script from "./RSS.vue?vue&type=script&lang=js&"
export * from "./RSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports